import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@app/core/auth/auth-guard.service';

const routes: Routes = [
  // { path: 'administration', component: PrincipalAdministrationComponent, canLoad: [AuthGuardService]},
  {
    path: 'coordination',
    // loadChildren: './coordination/coordination.module#CoordinationModule',
    loadChildren: () => import('./coordination/coordination.module').then(m => m.CoordinationModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'administration',
    // loadChildren: './administration/administration.module#AdministrationModule',
    loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'facilities',
    // loadChildren: './facilities/facilities.module#FacilitiesModule',
    loadChildren: () => import('./facilities/facilities.module').then(m => m.FacilitiesModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'slot-monitoring',
    loadChildren: () => import('./slot-monitoring/slot-monitoring.module').then(m => m.SlotMonitoringModule),
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class FeaturesRoutingModule { }
